


















import { SocialIcon, Flex } from '../../atoms'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { APPLE_SOCIAL } from '@/constant/social'
import { mapGetters } from 'vuex'
import { APP_MODULE, TRANSLATE } from '@/store/modules/app/constant'

@Component({
  components: {
    SocialIcon,
    Flex
  },
  computed: {
    ...mapGetters(APP_MODULE, [TRANSLATE])
  },
})
export default class SocialLoginBox extends Vue {
  @Prop({ required: true, type: String }) readonly social!: string
  @Prop({ type: String, default: '' }) readonly dataAction?: string
  @Prop({ type: String, default: '' }) readonly dataFnAction?: string
  get isAppleSocial(): boolean {
    return this.social === APPLE_SOCIAL
  }
}
